
(async () => {
  const DATA_URL = "https://cdn.shopify.com/s/files/1/1425/8892/files/bfcm-items.json?v=1753756214";
  const CACHE_KEY = "discountedPrices_data";
  const META_KEY = "discountedPrices_meta";
  const MAX_AGE = 12 * 60 * 60 * 1000;

  const now = Date.now();
  const meta = JSON.parse(localStorage.getItem(META_KEY) || "{}");

  const isFresh = (
    meta.url === DATA_URL &&
    typeof meta.timestamp === "number" &&
    (now - meta.timestamp) < MAX_AGE
  );

  if (isFresh) {
    try {
      window.discountedPrices = JSON.parse(localStorage.getItem(CACHE_KEY));
      console.log("[discountedPrices] ✅ Loaded discountedPrices from cache");
      return;
    } catch (e) {
      console.warn("[discountedPrices] ⚠️ Failed to parse cached data, refetching...");
    }
  }

  try {
    const res = await fetch(DATA_URL);
    if (!res.ok) throw new Error(`Fetch failed with status ${res.status}`);

    const json = await res.json();
    window.discountedPrices = json;

    localStorage.setItem(CACHE_KEY, JSON.stringify(json));
    localStorage.setItem(META_KEY, JSON.stringify({
      url: DATA_URL,
      timestamp: now
    }));

    console.log("[discountedPrices] 🔄 Fetched and cached discountedPrices");
  } catch (e) {
    console.error("[discountedPrices] ❌ Failed to fetch discountedPrices:", e);

    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        window.discountedPrices = JSON.parse(cached);
        console.warn("[discountedPrices] ⚠️ Using stale cached data");
      } catch (_) {
        console.error("[discountedPrices] 🚫 No usable data available");
      }
    }
  }
})(); 
    